import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(3)};
  `,
}
